module.exports = __webpack_public_path__ + "static/media/turn_on_circle.10f7ac17.svg";